export enum SalaryRestrictionStatus {
  MinimalniNezabavitelnaCastka = 'MinimalniNezabavitelnaCastka',
  Zablokovano = 'Zablokovano',
}
